import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { client } = props;

  let crumbs = [
        {name: 'Clients', path: 'advisory-clients'},
        {name: 'All Clients', path: 'advisory-clients/all'},
        {name: '...', path: '#'},
  ];

  if (client != null) {
    crumbs[2] =  { name: `${client.title}`, path: `advisory-clients/${client._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
